import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { addProductToProductHistory } from '@/domains/productDiscovery/Recommendation/modules/ProductHistory/ProductHistory.actions';

export const useAddToProductHistory = (productId?: number) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (productId) {
      dispatch(addProductToProductHistory(productId as number));
    }
  }, [productId, dispatch]);
};
